module.exports = __webpack_public_path__ + "img/1-black.90d8a75b.png";